import type { CacheBackend } from "@pdfking/compatibility"

import { RequestHandler } from "@pdfking/functionpool"
import { KeyDrop } from "@pdfking/tfunc"

import type { APIResponse } from "../types/api/APIResponse"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import type { TrackingInterface } from "../types/tasks/tracking/TrackingInterface"

import { CreateEngineMaster } from "../engine/CreateEngineMaster"
import { APIReceiver } from "../engine/receiver/APIReceiver"

type EngineOptions = Partial<
  {
    readonly cache: CacheBackend<APIResponse[]>
  } & PdfEngineOptions
>

export const CreateEngine = (
  config: EngineOptions = {},
  tracking_interface: TrackingInterface | undefined = undefined
): PdfEngine =>
  CreateEngineMaster(
    KeyDrop(config, ["cache"]),
    forward => RequestHandler(APIReceiver, forward),
    config.cache,
    tracking_interface
  )
